<div class="menu">
  <ng-container *ngFor="let item of getNavigation">
    <div class="item {{ currentRoute(item.paths) ? 'item-active': ''}}" [routerLink]="item.route">
      <fa-icon [icon]="item.icon"></fa-icon>
      <span>{{item.label}}</span>
    </div>
  </ng-container>
</div>
